import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-form-welcome-text-wrapper" }
const _hoisted_2 = { class: "flex justify-content-center mb-5" }
const _hoisted_3 = {
  alt: "qr code",
  width: "200"
}
const _hoisted_4 = { class: "p-fluid grid" }
const _hoisted_5 = {
  class: "col-12",
  style: {"padding-bottom":"0px"}
}
const _hoisted_6 = { class: "p-fluid grid" }
const _hoisted_7 = { class: "field col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_validation = _resolveComponent("validation")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GuestLayout = _resolveComponent("GuestLayout")!
  const _directive_auth_image = _resolveDirective("auth-image")!

  return (_openBlock(), _createBlock(_component_GuestLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
              [_directive_auth_image, _ctx.qrUrl]
            ])
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("auth.two_factor_auth_hint")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_validation, {
                validations: _ctx.v$.authCode,
                "show-errors": true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_InputText, {
                      id: "2fa",
                      type: "text",
                      class: "form-control",
                      modelValue: _ctx.authCode,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authCode) = $event)),
                      placeholder: `${_ctx.$t('general.qr_code')}`,
                      style: {"padding":"14px 24px","font-size":"16px","margin-bottom":"15px","border-radius":"26px"}
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                _: 1
              }, 8, ["validations"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  type: "submit",
                  id: "_submit",
                  name: "_submit",
                  class: "btn-mis--filled-white cm-btn cm-btn--lg btn-signin",
                  style: {"color":"black","width":"100%","padding":"14px 24px","font-size":"16px","margin-bottom":"15px","border-radius":"26px"},
                  label: _ctx.$t('auth.login'),
                  loading: _ctx.isLoading
                }, null, 8, ["label", "loading"])
              ])
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}